"use client";

import type { ReactNode } from "react";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useRef } from "react";

interface Props {
  href: string;
  ariaLabel?: string;
  ariaCurrent?: "page";
  className?: string;
  children: ReactNode;
  onIntent?: () => void;
}

/**
 * Haritadaki onlarca hedefi sayfa açılır açılmaz topluca prefetch etmek yerine,
 * yalnız kullanıcının yöneldiği hal detayını ısıtır. Link istemci içi geçiş
 * yaptığı için tıklamada tüm HTML/CSS/JS yeniden indirilmez.
 */
export default function MarketMapLink({ href, ariaLabel, ariaCurrent, className, children, onIntent }: Props) {
  const router = useRouter();
  const prefetched = useRef(false);

  function prefetchTarget() {
    onIntent?.();
    if (prefetched.current) return;
    prefetched.current = true;
    router.prefetch(href);
  }

  return (
    <Link
      href={href}
      prefetch={false}
      aria-label={ariaLabel}
      aria-current={ariaCurrent}
      className={className}
      onPointerEnter={prefetchTarget}
      onPointerDown={prefetchTarget}
      onFocus={prefetchTarget}
    >
      {children}
    </Link>
  );
}
